module.exports = __webpack_public_path__ + "img/apple-music-lyrics.16bc0969.png";